import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import DocumentCenterLanding from "@/pages/DocumentCenterLanding";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<DocumentCenterLanding />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
